import { en, TranslationKeys } from './en';
import { es } from './es';
import { fr } from './fr';
import { de } from './de';
import { sv } from './sv';
import { ar } from './ar';
import { LanguageCode } from '../config';
import { LocalizedTranslations } from '../localizedTranslations';

export type { TranslationKeys };
export type { LocalizedTranslations };

export const translations: Record<LanguageCode, LocalizedTranslations> = {
  en,
  es,
  fr,
  de,
  sv,
  ar,
};

export { en, es, fr, de, sv, ar };
